import { render, staticRenderFns } from "./Conferences.vue?vue&type=template&id=e928b6c0&"
import script from "./Conferences.vue?vue&type=script&lang=js&"
export * from "./Conferences.vue?vue&type=script&lang=js&"
import style0 from "./Conferences.vue?vue&type=style&index=0&id=e928b6c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports